import saqA from "./a.json";
import saqAEp from "./a_ep.json";
import saqB from "./b.json";
import saqBIp from "./b_ip.json";
import saqC from "./c.json";
import saqCVt from "./c_vt.json";
import saqD from "./d.json";
import saqDSp from "./d_sp.json";
import saqP2pe from "./p2pe.json";
import saqSpoc from "./spoc.json";

export interface SaqRequirementDetails {
    section_category?: string;
    section_requirement?: string;
    section_subtitle?: string;
    section_number?: string;
    section_description?: string;
    section_testing?: string;
    applicability_notes?: string;
    free_trial_enabled?: boolean;
}

export interface SaqFormSection {
    nav_title?: string;
    title?: string;
    requirements?: Record<string, SaqRequirementDetails>;
    pdf_layout?: string;
}

export type SaqFormDictionary = Record<string, SaqFormSection>;

const DEFAULT_SAQ_DICTIONARY = saqDSp as SaqFormDictionary;

const normalizeFormType = (formType: string): string =>
    formType
        .trim()
        .toUpperCase()
        .replace(/\s+/g, " ")
        .replace(/\s*\(\s*/g, " (")
        .replace(/\s*\)\s*/g, ")")
        .replace(/\s*-\s*/g, " ")
        .trim();

export const resolveSaqFormDictionary = (formType: string | null | undefined): SaqFormDictionary => {
    if (typeof formType !== "string" || !formType.trim()) {
        return DEFAULT_SAQ_DICTIONARY;
    }

    const normalized = normalizeFormType(formType);
    if (!normalized.startsWith("SAQ")) {
        return DEFAULT_SAQ_DICTIONARY;
    }

    if (normalized.startsWith("SAQ A (EP)")) {
        return saqAEp as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ A")) {
        return saqA as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ B (IP)")) {
        return saqBIp as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ B")) {
        return saqB as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ C (VT)")) {
        return saqCVt as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ C")) {
        return saqC as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ D (SP)")) {
        return saqDSp as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ D")) {
        return saqD as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ P2PE")) {
        return saqP2pe as SaqFormDictionary;
    }

    if (normalized.startsWith("SAQ SPOC")) {
        return saqSpoc as SaqFormDictionary;
    }

    return DEFAULT_SAQ_DICTIONARY;
};
